import _ from 'lodash';
import actionTypes from './action-types';

const namespace = 'app';

export const CHECK_ACCESS = `${namespace}_CHECK_ACCESS`;

export const checkAccess = (permission = '', hasAccess) => (dispatch, getState) => {
  const {
    app: { validators },
    session: { privileges },
  } = getState();
  if (hasAccess) {
    return hasAccess;
  }

  const newActionKey = permission.replace(/(-)/g, '.');
  const privilege = _.get(privileges, newActionKey);
  return !!privilege && (privilege === newActionKey || privilege.id === newActionKey) && dispatch(checkValidators(validators, newActionKey));
};

export const checkValidators = (validators, model, actionKey) => (dispatch, getState) => (_.get(validators, actionKey) || []).every((fn) => fn.call(null));

export const checkValidatorsLazy = (actionKey) => (dispatch, getState) => {
  const {
    app: { validators },
  } = getState();
  return {
    check: (model) => checkValidators(validators, model, actionKey),
  };
};

export const checkAccessLazy = (actionKey) => (dispatch, getState) => {
  const {
    app: { validators },
  } = getState();
  return {
    check: (model, hasAccess = false) => checkAccess(actionKey, hasAccess),
  };
};

export const fetchConfigRequest = () => ({
  type: actionTypes.FETCH_CONFIG_REQUEST,
});

export const fetchConfigSuccess = (config) => ({
  type: actionTypes.FETCH_CONFIG_SUCCESS,
  config,
});

export const fetchConfigFailure = () => ({
  type: actionTypes.FETCH_CONFIG_FAILURE,
});



// WEBPACK FOOTER //
// ./src/modules/app/actions/app.actions.js